import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es.json';
import pt from './pt.json';

/** D18/D33: sólo la interfaz cambia de idioma; el contenido va en un solo idioma. */
export const IDIOMAS = { ES: 'es', PT_BR: 'pt' } as const;
export type CodigoIdioma = (typeof IDIOMAS)[keyof typeof IDIOMAS];

const CLAVE_ALMACEN = 'pm_idioma';

export function idiomaGuardado(): CodigoIdioma {
  const v = localStorage.getItem(CLAVE_ALMACEN);
  return v === 'pt' ? 'pt' : 'es';
}

export function cambiarIdioma(codigo: CodigoIdioma): void {
  localStorage.setItem(CLAVE_ALMACEN, codigo);
  void i18n.changeLanguage(codigo);
  document.documentElement.lang = codigo;
}

void i18n.use(initReactI18next).init({
  resources: { es: { translation: es }, pt: { translation: pt } },
  lng: idiomaGuardado(),
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
